import React from 'react';
export const Footer: React.FC = () => {
  return <footer className="text-center py-10 px-6 text-xs leading-relaxed" style={{
    borderTop: '1px solid var(--border-subtle)',
    color: 'var(--text-muted)'
  }} data-id="element-69">
      <div className="container mx-auto max-w-3xl space-y-3" data-id="element-70">
        <p data-id="element-71">Sitio protegido con encriptación SSL · Compra 100% segura</p>
        <p data-id="element-72">© 2026 Oro en la Calle. Todos los derechos reservados.</p>
        <p data-id="element-73">
          Este producto es un material digital descargable. Al realizar la
          compra, recibís acceso inmediato al contenido completo.
          <br data-id="element-74" />
          Procesado de forma segura por Hotmart, plataforma líder en productos
          digitales.
        </p>
        <p data-id="element-75">
          Este sitio no forma parte de Facebook, Google ni de ninguna de sus
          empresas asociadas.
        </p>
      </div>
    </footer>;
};